import { Result } from 'core/infrastructure';
import { Preconditions } from 'core/infrastructure-next';
import * as TakeOutOrderStore from './TakeOutOrderStore';
import { Permission } from 'core/api';
import { Command } from 'pos/common';

declare global {
	interface CommandType {
		markTakeOutOrderAsPrepared: (orderId: number) => Promise<Result>
	}
}

Command.register('markTakeOutOrderAsPrepared', Preconditions.and(Preconditions.ensure(Permission.SalesOrder_MarkAsPrepared), Preconditions.ensureIsNotLite), async (orderId: number): Promise<Result> => {
	await TakeOutOrderStore.markAsPrepared(orderId);
	return Result.ok();
});
